import { module } from 'angular';

import pieChartComponent from './pie-chart/pie-chart.component';
import gaugeChartComponent from './gauge-chart/gauge-chart.component';

export default module('app.charts', [])
	.component('pieChart', pieChartComponent)
	.component('gaugeChart', gaugeChartComponent)
	.name;
